// tooltip.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private activeTooltipId = new Subject<string | null>();
  activeTooltipId$ = this.activeTooltipId.asObservable();

  openTooltip(id: string) {
    this.activeTooltipId.next(id);
  }

  closeTooltips() {
    this.activeTooltipId.next(null);
  }
}